import React from 'react';
import { COCKPIT_HEALTH_CHECKS, COCKPIT_TENANT } from './cockpit-data.jsx';
import { Icon } from './icons.jsx';
// Cockpit: Tab Saúde do Tenant + RepairActionModal (compartilhado)

// ── RepairActionModal ─────────────────────────────────────────────────────────
const RepairActionModal = ({ open, action, onClose, onConfirm }) => {
  const [motivo, setMotivo] = React.useState('');
  const [understood, setUnderstood] = React.useState(false);

  React.useEffect(() => {
    if (!open) { setMotivo(''); setUnderstood(false); }
  }, [open]);

  if (!open || !action) return null;

  const needsReason = action.requiresReason !== false;
  const canConfirm  = (!needsReason || motivo.trim().length >= 3) && understood;
  const iconName    = action.danger ? 'alert' : 'wrench';
  const iconColor   = action.danger ? 'var(--danger)' : 'var(--warning)';
  const iconBg      = action.danger ? 'var(--danger-bg)' : 'var(--warning-bg)';

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.52)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)', animation: 'scale-in 160ms cubic-bezier(0.2,0.8,0.2,1)' }}>
        <div style={{ padding: '24px 24px 0', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
          <div style={{ width: 44, height: 44, borderRadius: '50%', background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name={iconName} size={20} style={{ color: iconColor }} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>{action.name}</div>
            <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.55 }}>{action.impact || action.desc}</div>
          </div>
        </div>
        <div style={{ padding: '20px 24px' }}>
          {needsReason && (
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Motivo *</label>
              <textarea value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Descreva o motivo desta ação…" rows={3} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', lineHeight: 1.5 }} />
            </div>
          )}
          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
            <input type="checkbox" checked={understood} onChange={e => setUnderstood(e.target.checked)} style={{ marginTop: 2, flexShrink: 0 }} />
            <span>Entendo o impacto desta ação e confirmo que foi aprovada internamente.</span>
          </label>
        </div>
        <div style={{ padding: '14px 24px', background: 'var(--bg-subtle)', borderTop: '1px solid var(--border)', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn ghost" onClick={onClose}>Cancelar</button>
          <button className={'btn ' + (action.danger ? 'danger' : 'primary')} disabled={!canConfirm} onClick={() => canConfirm && onConfirm(motivo)} style={{ opacity: canConfirm ? 1 : 0.45 }}>
            {action.confirmLabel || 'Confirmar'}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── HealthScoreCard ───────────────────────────────────────────────────────────
const HealthScoreCard = ({ score, checks, onRunDiag }) => {
  const ok      = checks.filter(c => c.status === 'ok').length;
  const warn    = checks.filter(c => c.status === 'warning').length;
  const err     = checks.filter(c => c.status === 'error').length;
  const cls     = score >= 85 ? { label: 'Saudável', color: 'var(--success)', bg: 'var(--success-bg)' }
                : score >= 70 ? { label: 'Atenção',  color: 'var(--warning)', bg: 'var(--warning-bg)' }
                :               { label: 'Crítico',  color: 'var(--danger)',  bg: 'var(--danger-bg)'  };
  return (
    <div className="card" style={{ padding: '20px 24px', marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 28, flexWrap: 'wrap' }}>
        <div style={{ textAlign: 'center', minWidth: 70 }}>
          <div style={{ fontSize: 44, fontWeight: 700, lineHeight: 1, color: cls.color, letterSpacing: '-0.03em' }}>{score}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2, fontWeight: 500 }}>de 100</div>
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <span style={{ fontSize: 15, fontWeight: 600 }}>Saúde do tenant</span>
            <span style={{ padding: '3px 10px', borderRadius: 20, background: cls.bg, color: cls.color, fontSize: 12, fontWeight: 600 }}>{cls.label}</span>
          </div>
          <div style={{ height: 8, background: 'var(--bg-subtle)', borderRadius: 4, overflow: 'hidden', marginBottom: 10 }}>
            <div style={{ height: '100%', width: score + '%', background: cls.color, borderRadius: 4, transition: 'width 700ms ease' }} />
          </div>
          <div style={{ display: 'flex', gap: 18, fontSize: 12 }}>
            <span style={{ color: 'var(--success)', fontWeight: 500 }}>{ok} OK</span>
            <span style={{ color: 'var(--warning)', fontWeight: 500 }}>{warn} {warn === 1 ? 'aviso' : 'avisos'}</span>
            <span style={{ color: 'var(--danger)', fontWeight: 500 }}>{err} {err === 1 ? 'erro' : 'erros'}</span>
          </div>
        </div>
        <button className="btn primary" style={{ flexShrink: 0 }} onClick={onRunDiag}>
          <Icon name="activity" size={14} />Rodar diagnóstico
        </button>
      </div>
    </div>
  );
};

// ── HealthCheckCard ───────────────────────────────────────────────────────────
const STATUS_CFG = {
  ok:           { icon: 'check',    color: 'var(--success)', bg: 'var(--success-bg)', label: 'OK'               },
  warning:      { icon: 'alert',    color: 'var(--warning)', bg: 'var(--warning-bg)', label: 'Atenção'           },
  error:        { icon: 'x',        color: 'var(--danger)',  bg: 'var(--danger-bg)',  label: 'Erro'              },
  unconfigured: { icon: 'minus',    color: 'var(--text-muted)', bg: 'var(--bg-subtle)', label: 'Não configurado' },
};

const HealthCheckCard = ({ check, onRepair, onViewDetails }) => {
  const sc = STATUS_CFG[check.status] || STATUS_CFG.unconfigured;
  return (
    <div className="card" style={{ padding: '14px 16px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
      <div style={{ width: 32, height: 32, borderRadius: 8, background: sc.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: sc.color }}>
        <Icon name={sc.icon} size={15} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 3, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 13, fontWeight: 600 }}>{check.name}</span>
          <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 4, background: sc.bg, color: sc.color, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{sc.label}</span>
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 5, lineHeight: 1.45 }}>{check.desc}</div>
        <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Verificado {check.lastCheck}</div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flexShrink: 0, alignSelf: 'center' }}>
        <button className="btn ghost sm" style={{ fontSize: 11, height: 26, padding: '0 8px' }} onClick={() => onViewDetails(check)}>
          Ver detalhes
        </button>
        {check.repairAction && (
          <button onClick={() => onRepair(check)} style={{ height: 26, padding: '0 8px', border: 'none', borderRadius: 6, background: 'var(--warning-bg)', color: 'var(--warning)', fontSize: 11, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
            <Icon name="wrench" size={11} />Reparar
          </button>
        )}
      </div>
    </div>
  );
};

// ── CockpitHealthTab ──────────────────────────────────────────────────────────
const HEALTH_CATEGORIES = [
  { id: 'infra',    label: 'Infraestrutura',  icon: 'server'   },
  { id: 'domain',   label: 'Domínios',         icon: 'globe'    },
  { id: 'store',    label: 'Loja',             icon: 'store'    },
  { id: 'access',   label: 'Acesso',           icon: 'users'    },
  { id: 'catalog',  label: 'Catálogo',         icon: 'layers'   },
  { id: 'security', label: 'Segurança',        icon: 'shield'   },
];

const REPAIR_ACTIONS = {
  'validate-dns':    { name: 'Validar DNS',                     impact: 'Verificará a propagação DNS do domínio customizado. Nenhum dado será alterado.',                                                    requiresReason: false, danger: false, confirmLabel: 'Validar agora'   },
  'reindex':         { name: 'Reindexar busca',                  impact: 'O índice de busca será reconstruído. Pode levar alguns minutos e aumentar a carga do servidor temporariamente.',                    requiresReason: false, danger: false, confirmLabel: 'Reindexar'       },
  'rotate-tokens':   { name: 'Revogar e rotacionar tokens',      impact: 'Todos os tokens públicos de API serão invalidados imediatamente. Qualquer integração ativa precisará ser reconfigurada com o novo token.', requiresReason: true, danger: true,  confirmLabel: 'Revogar tokens'  },
};

const CockpitHealthTab = ({ cockpitData, onToast }) => {
  const [detailDrawer, setDetailDrawer]   = React.useState(null);
  const [repairModal,  setRepairModal]    = React.useState(null);

  const handleRepair = (check) => {
    const def = REPAIR_ACTIONS[check.repairAction];
    if (!def) return;
    setRepairModal({ ...def, checkName: check.name });
  };

  const handleRepairConfirm = (motivo) => {
    onToast(`Repair "${repairModal.name}" executado com sucesso`);
    setRepairModal(null);
  };

  return (
    <div>
      <HealthScoreCard score={(cockpitData?.tenant || COCKPIT_TENANT).healthScore} checks={cockpitData?.healthChecks || COCKPIT_HEALTH_CHECKS} onRunDiag={() => onToast('Diagnóstico completo iniciado…')} />

      {HEALTH_CATEGORIES.map(cat => {
        const checks = (cockpitData?.healthChecks || COCKPIT_HEALTH_CHECKS).filter(c => c.category === cat.id);
        if (!checks.length) return null;
        return (
          <div key={cat.id} style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <Icon name={cat.icon} size={14} style={{ color: 'var(--text-muted)' }} />
              <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-muted)' }}>{cat.label}</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              {checks.map(check => (
                <HealthCheckCard key={check.id} check={check} onRepair={handleRepair} onViewDetails={setDetailDrawer} />
              ))}
            </div>
          </div>
        );
      })}

      {/* Detail drawer */}
      {detailDrawer && (
        <div className="drawer-overlay" onClick={() => setDetailDrawer(null)}>
          <div className="drawer" onClick={e => e.stopPropagation()}>
            <div className="drawer-head">
              <div style={{ flex: 1 }}>
                <h3>{detailDrawer.name}</h3>
                <div className="sub">Detalhes técnicos do check</div>
              </div>
              <button className="icon-action" onClick={() => setDetailDrawer(null)}><Icon name="x" size={16} /></button>
            </div>
            <div className="drawer-body">
              <div className="drawer-section">
                <h4>Status</h4>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 0' }}>
                  <div style={{ width: 36, height: 36, borderRadius: 8, background: STATUS_CFG[detailDrawer.status]?.bg, color: STATUS_CFG[detailDrawer.status]?.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Icon name={STATUS_CFG[detailDrawer.status]?.icon} size={18} />
                  </div>
                  <div>
                    <div style={{ fontWeight: 600 }}>{STATUS_CFG[detailDrawer.status]?.label}</div>
                    <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Verificado: {detailDrawer.lastCheck}</div>
                  </div>
                </div>
                <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6, margin: 0 }}>{detailDrawer.desc}</p>
              </div>
              <div className="drawer-section">
                <h4>Output técnico</h4>
                <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12, color: 'var(--text-secondary)', background: 'var(--bg-subtle)', padding: 14, borderRadius: 8, lineHeight: 1.7 }}>
                  {detailDrawer.status === 'ok'
                    ? `✓ [PASS] ${detailDrawer.id}\n  schema: loja_exemplo_premium\n  checked: ${detailDrawer.lastCheck}\n  result: healthy`
                    : `⚠ [${detailDrawer.status.toUpperCase()}] ${detailDrawer.id}\n  schema: loja_exemplo_premium\n  checked: ${detailDrawer.lastCheck}\n  detail: ${detailDrawer.desc}`}
                </div>
              </div>
              {detailDrawer.repairAction && (
                <div>
                  <h4 style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-muted)', marginBottom: 10 }}>Ação disponível</h4>
                  <button className="btn" style={{ background: 'var(--warning-bg)', color: 'var(--warning)', border: '1px solid color-mix(in srgb, var(--warning) 25%, transparent)' }} onClick={() => { setDetailDrawer(null); handleRepair(detailDrawer); }}>
                    <Icon name="wrench" size={14} />Reparar agora
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <RepairActionModal open={!!repairModal} action={repairModal} onClose={() => setRepairModal(null)} onConfirm={handleRepairConfirm} />
    </div>
  );
};

export {
  CockpitHealthTab,
  HealthCheckCard,
  HealthScoreCard,
  RepairActionModal,
  STATUS_CFG,
};
